import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { submitContactForm } from '../../../services/api';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    preferredContact: 'phone'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const subjects = [
    { value: 'demo', label: 'Demo Talebi' },
    { value: 'pricing', label: 'Fiyat Bilgisi' },
    { value: 'technical', label: 'Teknik Sorular' },
    { value: 'partnership', label: 'Ortaklık' },
    { value: 'support', label: 'Destek' },
    { value: 'other', label: 'Diğer' }
  ];

  const contactMethods = [
    { value: 'phone', label: 'Telefon' },
    { value: 'email', label: 'E-posta' },
    { value: 'whatsapp', label: 'WhatsApp' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // API call
      await submitContactForm(formData);
      setIsSubmitted(true);
    } catch (error) {
      console.error('Contact form failed:', error);
      alert('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Merhaba! Cafe Otomasyonu hakkında bilgi almak istiyorum.');
    window.open(`https://wa.me/905075880481?text=${message}`, '_blank');
  };

  if (isSubmitted) {
    return (
      <section id="iletisim" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-green-50 rounded-2xl p-12">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckCircle" size={40} className="text-green-600" />
            </div>

            <h2 className="font-poppins font-heading-bold text-3xl text-foreground mb-4">
              Mesajınız İletildi!
            </h2>

            <p className="font-open-sans font-body-normal text-lg text-text-secondary mb-8">
              En kısa sürede sizinle iletişime geçeceğiz. Acil durumlar için WhatsApp hattımızı kullanabilirsiniz.
            </p>

            <Button
              variant="default"
              size="lg"
              onClick={handleWhatsAppClick}
              iconName="MessageCircle"
              iconPosition="left"
            >
              WhatsApp ile İletişim
            </Button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="iletisim" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="MessageCircle" size={16} />
            <span className="font-inter font-accent-medium text-sm">
              İletişim
            </span>
          </div>

          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-6">
            Ücretsiz{' '}
            <span className="text-primary">Danışmanlık</span>
          </h2>

          <p className="font-open-sans font-body-normal text-xl text-text-secondary max-w-3xl mx-auto">
            Uzmanlarımızla görüşün, işletmeniz için en uygun çözümü birlikte belirleyin
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left - Contact Information */}
          <div className="space-y-8">
            {/* Contact Methods */}
            <div className="bg-white rounded-2xl p-8 shadow-sm">
              <h3 className="font-poppins font-heading-semibold text-2xl text-foreground mb-6">
                Bize Ulaşın
              </h3>

              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                    <Icon name="Phone" size={24} className="text-blue-600" />
                  </div>
                  <div>
                    <h4 className="font-inter font-accent-semibold text-foreground">
                      Telefon
                    </h4>
                    <p className="font-open-sans font-body-normal text-text-secondary">
                      +90 507 588 04 81
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      Pazartesi - Cuma: 09:00 - 18:00
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                    <Icon name="MessageCircle" size={24} className="text-green-600" />
                  </div>
                  <div>
                    <h4 className="font-inter font-accent-semibold text-foreground">
                      WhatsApp
                    </h4>
                    <p className="font-open-sans font-body-normal text-text-secondary">
                      +90 507 588 04 81
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      7/24 Hızlı Destek
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                    <Icon name="Mail" size={24} className="text-purple-600" />
                  </div>
                  <div>
                    <h4 className="font-inter font-accent-semibold text-foreground">
                      E-posta
                    </h4>
                    <p className="font-open-sans font-body-normal text-text-secondary">
                      info@cafeotomasyonu.com
                    </p>
                    <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                      24 saat içinde yanıt
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <Icon name="MapPin" size={24} className="text-orange-600" />
                  </div>
                  <div>
                    <h4 className="font-inter font-accent-semibold text-foreground">
                      Adres
                    </h4>
                    <p className="font-open-sans font-body-normal text-text-secondary">
                      Maslak Mahallesi, Teknoloji Caddesi<br />
                      No: 15, Sarıyer/İstanbul
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-white rounded-2xl p-8 shadow-sm">
              <h3 className="font-poppins font-heading-semibold text-xl text-foreground mb-6">
                Hızlı İşlemler
              </h3>

              <div className="space-y-4">
                <Button
                  variant="outline"
                  size="lg"
                  fullWidth
                  onClick={() => window.open('/franchise', '_self')}
                  iconName="Briefcase"
                  iconPosition="left"
                  className="justify-start"
                >
                  Bayilik Başvurusu
                </Button>

                <Button
                  variant="outline"
                  size="lg"
                  fullWidth
                  onClick={handleWhatsAppClick}
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="justify-start"
                >
                  WhatsApp ile Hızlı Destek
                </Button>

                <Button
                  variant="outline"
                  size="lg"
                  fullWidth
                  onClick={() => window.open('https://panel.cafeotomasyonu.com', '_blank')}
                  iconName="Play"
                  iconPosition="left"
                  className="justify-start"
                >
                  Demo Randevusu Al
                </Button>

                <Button
                  variant="outline"
                  size="lg"
                  fullWidth
                  onClick={() => {
                    const element = document.getElementById('fiyatlandirma');
                    if (element) {
                      const offsetTop = element.offsetTop - 80;
                      window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                      });
                    }
                  }}
                  iconName="CreditCard"
                  iconPosition="left"
                  className="justify-start"
                >
                  Fiyat Bilgisi Al
                </Button>
              </div>
            </div>

            {/* Map */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  loading="lazy"
                  title="Cafe Otomasyonu Ofis"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps?q=41.1079,29.0175&z=14&output=embed"
                  className="border-0"
                />
              </div>
            </div>
          </div>

          {/* Right - Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Icon name="Send" size={32} color="white" />
              </div>

              <h3 className="font-poppins font-heading-bold text-2xl text-foreground mb-2">
                Mesaj Gönderin
              </h3>

              <p className="font-open-sans font-body-normal text-text-secondary">
                Sorularınızı bize iletin, en kısa sürede yanıtlayalım
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <Input
                  label="Adınız Soyadınız"
                  type="text"
                  placeholder="Mehmet Özkan"
                  value={formData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  required
                />

                <Input
                  label="Telefon"
                  type="tel"
                  placeholder="0532 123 45 67"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  required
                />
              </div>

              <Input
                label="E-posta Adresi"
                type="email"
                placeholder="mehmet@ozkan.com"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                required
              />

              <Select
                label="Konu"
                placeholder="Mesaj konusunu seçin"
                options={subjects}
                value={formData.subject}
                onChange={(value) => handleInputChange('subject', value)}
                required
              />

              <div>
                <label className="block font-open-sans font-body-medium text-sm text-text-secondary mb-2">
                  Mesajınız
                </label>
                <textarea
                  placeholder="İşletmeniz hakkında kısa bilgi verin ve sorularınızı yazın..."
                  value={formData.message}
                  onChange={(e) => handleInputChange('message', e.target.value)}
                  rows={5}
                  required
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none font-open-sans font-body-normal text-sm"
                />
              </div>

              <Select
                label="Tercih Ettiğiniz İletişim Yöntemi"
                placeholder="Nasıl ulaşalım?"
                options={contactMethods}
                value={formData.preferredContact}
                onChange={(value) => handleInputChange('preferredContact', value)}
                required
              />

              <Button
                type="submit"
                variant="default"
                size="lg"
                fullWidth
                loading={isSubmitting}
                iconName="Send"
                iconPosition="left"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
              </Button>

              <div className="text-center">
                <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                  Mesajınız 24 saat içinde yanıtlanacaktır. Acil durumlar için WhatsApp kullanın.
                </p>
              </div>
            </form>

            {/* Response Time */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <Icon name="Clock" size={24} className="text-blue-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-semibold text-sm text-foreground">
                    &lt; 2 saat
                  </p>
                  <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                    WhatsApp yanıt
                  </p>
                </div>

                <div>
                  <Icon name="Mail" size={24} className="text-green-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-semibold text-sm text-foreground">
                    &lt; 24 saat
                  </p>
                  <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                    E-posta yanıt
                  </p>
                </div>

                <div>
                  <Icon name="Phone" size={24} className="text-purple-600 mx-auto mb-2" />
                  <p className="font-inter font-accent-semibold text-sm text-foreground">
                    Anında
                  </p>
                  <p className="font-open-sans font-body-normal text-xs text-text-secondary">
                    Telefon desteği
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white">
            <h3 className="font-poppins font-heading-bold text-2xl mb-4">
              Hemen Başlayın!
            </h3>
            <p className="font-open-sans font-body-normal text-lg opacity-90 mb-6 max-w-2xl mx-auto">
              Bugün iletişime geçin, yarın dijital dönüşümünüzü başlatın. İlk ay tamamen ücretsiz!
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="outline"
                size="lg"
                onClick={() => {
                  const element = document.getElementById('demo-request');
                  if (element) {
                    const offsetTop = element.offsetTop - 80;
                    window.scrollTo({
                      top: offsetTop,
                      behavior: 'smooth'
                    });
                  }
                }}
                className="bg-white text-primary border-white hover:bg-gray-100"
                iconName="Play"
                iconPosition="left"
              >
                Ücretsiz Demo Al
              </Button>

              <Button
                variant="outline"
                size="lg"
                onClick={handleWhatsAppClick}
                className="bg-transparent text-white border-white hover:bg-white/10"
                iconName="MessageCircle"
                iconPosition="left"
              >
                WhatsApp Destek
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;